<div class="page-content container">
  <div class="home-box-header">
    <span class="title-small">{{ translationManager.getTranslation('Електронски систем') }}</span>
    <span class="title">{{ translationManager.getTranslation('Добродошли на портал еНабавке') }}</span>
  </div>
  <div class="home-box shadow-sm">
    <div class="home-box-title">
      <span><i class="fas fa-info-circle"></i>{{ translationManager.getTranslation('Обавештења') }}</span>
    </div>
    <div *ngIf="isAuthenticated" class="home-box-widget">
      <inbox-supplier-offers-widget></inbox-supplier-offers-widget>
    </div>
  </div>
  <div class="home-box shadow-sm">
    <div class="home-box-title">
      <span><i class="fas fa-clock"></i>{{ translationManager.getTranslation('Акције на чекању') }}</span>
    </div>
    <div *ngIf="isAuthenticated" class="home-box-widget">
      <undelivered-supplier-offers-widget></undelivered-supplier-offers-widget>
    </div>
  </div>
</div>
